import { Component, Input } from '@angular/core';

import { AppliedToplineItem } from 'generated/graphql';
@Component({
  selector: 'app-highlighted-topline',
  templateUrl: './highlighted-topline.component.html',
  styleUrls: ['./highlighted-topline.component.scss']
})
export class HighlightedToplineComponent  {
  @Input() topline: Partial<AppliedToplineItem> | any;
  @Input() targetId: string;
  @Input() targetType: 'Entity' | 'EntityConnection';
  @Input() campaignId: string;
  @Input() parentEntityId: string;

  constructor(
  ) {
  }


  onAddClicked() {
    console.warn('onAddClick not implemnted on HighlightedTopline');
  }
}
